import {vnModule_knockoutJS} from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import {header} from "./header";
import {humanBotScoreDashboard_template} from "../components/templates/humanBotScoreDashboard_template";
import {vnAppZone} from '../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone';

declare var ko: any;

export class humanBotScoreDashboard extends vnModule_knockoutJS {

    protected humanBotScoreDashboard_template: humanBotScoreDashboard_template;
    protected zoneHeader: vnAppZone | null;

    protected getModuleName(): string {

        return 'humanBotScoreDashboard';
    }

    public buildContent(): Array<Element> {

        this.zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = this.zoneHeader?.loadedModule;
        (<header>loadedModule).setHeaderTitle('Human/Bot Score');

        this.humanBotScoreDashboard_template = new humanBotScoreDashboard_template('humanBotScoreDashboard', this.viewModel, this);
        this.template = this.humanBotScoreDashboard_template;

        return [this.humanBotScoreDashboard_template.build()];
    }

    public fillPage(): void {

        window.scrollTo(0, 0);
        this.getReferences();
    }

    public refreshReport(): void {

        this.getReportData();
    }

    public showIpDetail(row): void {

        if (!row || !row.ip) {
            return;
        }

        this.humanBotScoreDashboard_template.setSelectedIp(row.ip, row.brand || '');
        this.getReportData(row.ip, row.brand || '');
    }

    public clearIpDetail(): void {

        this.humanBotScoreDashboard_template.clearIpDetail();
    }

    protected getReferences(): void {

        this.humanBotScoreDashboard_template.setLoading(true);
        this.humanBotScoreDashboard_template.setError('');

        fetch('/api/human_bot_score/references/', {credentials: 'same-origin'})
            .then((response) => this.parseJsonResponse(response, 'Could not load dashboard references.'))
            .then((data) => {
                this.humanBotScoreDashboard_template.updateReferences(data);
                this.getReportData();
            })
            .catch((error) => {
                this.humanBotScoreDashboard_template.setError(error.message || 'Could not load dashboard references.');
                this.humanBotScoreDashboard_template.setLoading(false);
            });
    }

    protected getReportData(detailIp: string = '', detailBrand: string = ''): void {

        this.humanBotScoreDashboard_template.setLoading(true);
        this.humanBotScoreDashboard_template.setError('');

        fetch(this.buildReportUrl(detailIp, detailBrand), {credentials: 'same-origin'})
            .then((response) => this.parseJsonResponse(response, 'Could not load the human/bot score report.'))
            .then((data) => {
                this.humanBotScoreDashboard_template.updateReport(data);
                this.humanBotScoreDashboard_template.setLoading(false);
            })
            .catch((error) => {
                this.humanBotScoreDashboard_template.setError(error.message || 'Could not load the human/bot score report.');
                this.humanBotScoreDashboard_template.setLoading(false);
            });
    }

    protected buildReportUrl(detailIp: string = '', detailBrand: string = ''): string {

        const request = this.humanBotScoreDashboard_template.getViewModelForRequest();
        const params = [];

        Object.keys(request).forEach((key) => {
            if (request[key] !== null && request[key] !== '') {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(request[key]));
            }
        });

        if (detailIp) {
            params.push('ip=' + encodeURIComponent(detailIp));
        }

        if (detailBrand) {
            params.push('detail_brand=' + encodeURIComponent(detailBrand));
        }

        return '/api/human_bot_score/report/?' + params.join('&');
    }

    protected parseJsonResponse(response, fallbackMessage: string): Promise<any> {

        return response.json()
            .catch(() => ({}))
            .then((data) => {
                if (!response.ok) {
                    throw new Error(data.message || fallbackMessage);
                }

                return data;
            });
    }
}



// WEBPACK FOOTER //
// ./js/modules/humanBotScoreDashboard.ts